import type { TOC } from '@ember/component/template-only';
import type { SafeString } from '@ember/template';
import { PhStack } from 'ember-phosphor-icons';
interface AnchorMessageSignature {
  Args: {
    title: string | SafeString;
    body?: string | SafeString;
    /** `dot` for a leading bullet, `glyph` for the all-caught-up illustration. */
    variant?: 'dot' | 'glyph';
  };
  Element: HTMLDivElement;
}

/**
 * Informational anchor/empty-state card in the Needs Your Attention panel
 * (submitted, approved, course-cash-used, all-caught-up). No chip or CTA — these
 * never count toward the pending-task total.
 */
const AnchorMessage: TOC<AnchorMessageSignature> = <template>
  <div
    class="tio-row tio-bg-surface items-start gap-3 rounded-xl border tio-border-default p-4"
    ...attributes
  >
    {{#if (eq @variant "glyph")}}
      <PhStack @size={{20}} class="tio-fg-info shrink-0" />
    {{else}}
      <span class="tio-bg-info mt-1.5 h-2 w-2 shrink-0 rounded-full"></span>
    {{/if}}
    <div class="min-w-0">
      <div class="tio-text-sm-semibold tio-fg-primary">{{@title}}</div>
      {{#if @body}}
        <div class="tio-text-sm-normal tio-fg-secondary mt-0.5">{{@body}}</div>
      {{/if}}
    </div>
  </div>
</template>;

export default AnchorMessage;
